import React, { Component } from "react";
import { Link } from "react-router-dom";
import Sticky from "react-stickynode";

// Images
import logo from "../../../images/logo.png";
import salogo from "../../../images/salogo.png";

import i18n from "i18next";
import { withTranslation } from "react-i18next";

class Header1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLang: i18n.language,
    };
  }

  componentDidMount() {
    // 初始化语言选项
    this.setState({ selectedLang: i18n.language });

    // 监听语言选项的变化并更新选项的值
    i18n.on("languageChanged", (lang) => {
      this.setState({ selectedLang: lang });
    });

    // Mobile Menu sidebar function
    const btn = document.querySelector(".menuicon");
    const nav = document.querySelector(".menu-links");

    function toggleFunc() {
      if (!btn || !nav) return;
      btn.classList.toggle("open");
      nav.classList.toggle("show");
    }

    if (btn) btn.addEventListener("click", toggleFunc);

    // Mobile Submenu open close function
    const navMenu = [].slice.call(
      document.querySelectorAll(".menu-links > ul > li")
    );
    for (let y = 0; y < navMenu.length; y++) {
      navMenu[y].addEventListener("click", function () {
        menuClick(this);
      });
    }

    function menuClick(current) {
      const active = current.classList.contains("open");
      navMenu.forEach((el) => el.classList.remove("open"));

      if (active) {
        current.classList.remove("open");
      } else {
        current.classList.add("open");
      }
    }

    // 保存引用以便卸载时清理
    this._toggleFunc = toggleFunc;
    this._btnRef = btn;
    this._navMenuRefs = navMenu;
  }

  componentWillUnmount() {
    // 组件卸载时清除事件
    i18n.off("languageChanged");
    if (this._btnRef && this._toggleFunc) {
      this._btnRef.removeEventListener("click", this._toggleFunc);
    }
    if (this._navMenuRefs) {
      this._navMenuRefs.forEach((el) => el.replaceWith(el.cloneNode(true)));
    }
  }

  render() {
    const { t } = this.props;
    const { selectedLang } = this.state;

    const changeLanguage = (val) => {
      i18n.changeLanguage(val.target.value);
    };

    return (
      <>
        <header className="header rs-nav">
          {/* Top bar */}
          <div className="top-bar">
            <div className="container">
              <div className="row d-flex justify-content-between">
                <div className="topbar-left">
                </div>
                <div className="topbar-right">
                  <ul>
                    <li>
                      <select
                        className="header-lang-bx"
                        value={selectedLang}
                        onChange={changeLanguage}
                      >
                        <option data-icon="flag flag-uk" value="en">
                          English
                        </option>
                        <option data-icon="flag flag-us" value="zh">
                          中文
                        </option>
                      </select>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky main nav */}
          <Sticky enabled={true} className="sticky-header navbar-expand-lg">
            <div className="menu-bar clearfix">
              {/* 外层全宽 */}
              <div className="container-fluid">
                {/* 内层定宽且居中 */}
                <div className="nav-inner d-flex align-items-center justify-content-between mx-auto">
                  {/* SA Logo */}
                  <div className="menu-salogo">
                    <Link to="/">
                      <img alt="" src={salogo} />
                    </Link>
                  </div>

                  {/* Mobile Nav Button */}
                  <button
                    className="navbar-toggler collapsed menuicon justify-content-end"
                    type="button"
                    data-toggle="collapse"
                    data-target="#menuDropdown"
                    aria-controls="menuDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>

                  {/* Navigation Menu */}
                  <div
                    className="menu-links navbar-collapse collapse justify-content-start"
                    id="menuDropdown"
                  >
                    <div className="menu-logo">
                      <Link to="/">
                        <img alt="" src={logo} />
                      </Link>
                    </div>

                    <ul className="nav navbar-nav">
                      <li>
                        <Link to="/">{t("Header_Home")}</Link>
                      </li>
                      <li> 
                        <Link to="/about">
                            {t("Header_Leading_Coding_Introduction")}
                        </Link>
                      </li>
                      <li> 
                        <Link to="/director-profiles">
                            {t("Header_Director_Introduction")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/initiative-letter">
                            {t("Header_Initiative_Letter")}
                        </Link> 
                      </li>

                      <li>
                        <Link to="/photos">{t("Header_Achievements_Photos")}</Link>
                      </li>
                      
                      <li>
                        <Link to="/contact">{t("Header_Contact")}</Link>
                      </li>
                    </ul>
                  </div>
                  {/* Navigation Menu END */}
                </div>
              </div>
            </div>
          </Sticky>

          {/* Search Box */}
          <div className="nav-search-bar">
            <form action="#">
              <input
                name="search"
                type="text"
                className="form-control"
                placeholder="Type to search"
              />
              <span>
                <i className="ti-search"></i>
              </span>
            </form>
            <span id="search-remove">
              <i className="ti-close"></i>
            </span>
          </div>
        </header>
      </>
    );
  }
}

export default (Header1 = withTranslation()(Header1));
